import React from 'react';
import Iframe from 'react-iframe';

const SecondaryStatePage = () => (
  <Iframe
    url='https://visualization.audit.samiksha.samagra.io/public/dashboard/f229dade-f431-4640-b3ec-70c9625c58b0'
    width='100%'
    height='100%'
    display='initial'
    position='relative'
  />
);

export default SecondaryStatePage;
